import HotLeads from './HotLeads.component';

export default HotLeads;